import { Button, Grid, MenuItem, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import dayjs from 'dayjs'
import FormattedTextEditor from '../../../components/FormattedTextEditor/FormattedTextEditor'

const retornaLocalAtendimento = (u = []) => ({
  idMedicamento: u?.[0] || undefined,
  nrRegistro: u?.[1] || undefined,
  nmMedicamento: u?.[2] || '',
  dsInformacoes: u?.[3] || '',
  snFavorito: u?.[4] === 'S' ? true : false || false,
  dtFimVigencia: u?.[5] ? dayjs(u?.[5]).format('YYYY-MM-DD') : undefined,
  dsPosologia: u?.[6] || '',
})

const snFavoritoType = [
  [true, 'SIM'],
  [false, 'NÃO'],
]

const createAgenda = z.object({
  idMedicamento: z.number().optional(),
  nrRegistro: z.string().optional(),
  dsInformacoes: z.string().optional(),
  dsPosologia: z.string().optional(),
  dtFimVigencia: z.string().optional().nullable(),
  snFavorito: z.boolean().optional(),
  nmMedicamento: z.string().min(3, {
    message: 'Nome da agenda inválido',
  }),
})

const Edicao = ({ dados, voltar }) => {
  const [acTiposMedicamento, setAcTiposMedicamento] = useState(dados?.[7] || [])
  const [erroTiposMedicamento, setErroTiposMedicamento] = useState(false)
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados),
  })

  const salva = async (values) => {
    if (acTiposMedicamento.length === 0) {
      setErroTiposMedicamento(true)
      return
    }

    const payload = {
      ...values,
      tiposMedicamento: acTiposMedicamento.flatMap((item) => item?.[0] || []),
      dtFimVigencia: values.dtFimVigencia
        ? dayjs(values.dtFimVigencia).format('YYYY-MM-DD')
        : undefined,
    }
    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('nmMedicamento')}
            label="Nome"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.nmMedicamento}
            helperText={errors.nmMedicamento?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            {...register('nrRegistro')}
            label="Código/Registro"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.nrRegistro}
            helperText={errors.nrRegistro?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            {...register('snFavorito')}
            label="Favorito"
            fullWidth
            value={watch('snFavorito')}
            margin="dense"
            variant="outlined"
            select
            error={!!errors.snFavorito}
            helperText={errors.snFavorito?.message}
          >
            {snFavoritoType.map((item) => (
              <MenuItem key={item[0]} value={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            {...register('dtFimVigencia')}
            label="Fim da Vigência"
            fullWidth
            disabled
            margin="dense"
            variant="outlined"
            error={!!errors.dtFimVigencia}
            helperText={errors.dtFimVigencia?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <AutoComplete
            multiple
            filterSelectedOptions
            InputLabelProps={{ shrink: true }}
            label="Tipos de medicamento"
            metodo="buscaTipoDeMedicamento"
            value={acTiposMedicamento}
            onChange={(_, tipos) => {
              setAcTiposMedicamento(tipos)
              setErroTiposMedicamento(tipos.length === 0)
            }}
            textFieldProps={{
              error: erroTiposMedicamento,
              helperText: erroTiposMedicamento
                ? 'Selecione pelo menos um tipo de medicamento.'
                : '',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormattedTextEditor
            label="Informações/Composição"
            value={watch('dsInformacoes')}
            onChange={(valor) =>
              setValue('dsInformacoes', valor, { shouldDirty: true })
            }
            minHeight={180}
            error={!!errors.dsInformacoes}
            helperText={errors.dsInformacoes?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <FormattedTextEditor
            label="Posologia"
            value={watch('dsPosologia')}
            onChange={(valor) =>
              setValue('dsPosologia', valor, { shouldDirty: true })
            }
            minHeight={180}
            error={!!errors.dsPosologia}
            helperText={errors.dsPosologia?.message}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
